import { useContext, useEffect, useRef } from "react";

import { css } from "@emotion/react";

import ListChoice from "components/DesignComponents/ListChoice";
import LanguageContext from "context/language/languageContext";
import { noop } from "shared/functions";

import { ListOfLanguagesProps } from "./types";

const ListOfLanguages = ({ hasApiCall }: ListOfLanguagesProps) => {
    const { languages, language, setNewLanguage } = useContext(LanguageContext);

    const selectedRef = useRef<HTMLLIElement | null>(null);

    useEffect(() => {
        if (selectedRef.current) {
            selectedRef.current.scrollIntoView();
        }
    }, []);

    return (
        <>
            {languages.map(({ id, label }) => {
                const isSelected = id === language;

                return (
                    <ListChoice
                        ref={isSelected ? selectedRef : null}
                        key={id}
                        title={label}
                        selected={isSelected}
                        css={css({
                            pointerEvents: isSelected ? "none" : "auto"
                        })}
                        onClick={() =>
                            isSelected
                                ? noop()
                                : setNewLanguage(
                                      id,
                                      hasApiCall,
                                      !hasApiCall,
                                      true
                                  )
                        }
                    />
                );
            })}
        </>
    );
};

export default ListOfLanguages;
